import { jwtDecode } from "jwt-decode";

const token = JSON.parse(localStorage.getItem('cardsToken'));
export const config={
    headers:{
        authorization:`Bearer ${token}`,
    }
};
export const formatCompactDate = (dateStr) =>{
  if (!/^\d{8}$/.test(dateStr)) return null; 
  const year = dateStr.substring(0, 4);
  const month = dateStr.substring(4, 6);
  const day = dateStr.substring(6, 8);
  return `${day}/${month}/${year}`;
};
// check token
export const isTokenValid = (token) => {
  if (!token) return false;
  try {
    const decoded = jwtDecode(token);
    const currentTime = Date.now() / 1000; 
    return decoded.exp > currentTime;
  } catch (err) {
    return false;
  }
};
export const downloadAntdQR = (id,serial) => {
  const canvas = document.querySelector(`#qr-${id} canvas`);
  if (!canvas) return;
  const pngUrl = canvas.toDataURL("image/png");
  const link = document.createElement("a");
  link.href = pngUrl;
  link.download = `Bcard_${serial}.png`;
  link.click();
};


//axios Instance
// const apiUrl = process.env.REACT_APP_URL;
// export const axiosInstance = axios.create({
//   baseURL: apiUrl,
// });

// axiosInstance.interceptors.request.use(
//   (config) => {
//     const token = JSON.parse(localStorage.getItem("cardsToken"));
//     if (!isTokenValid(token)) {
//       localStorage.removeItem("cardsToken");
//       window.location.href = "/user/login";
//       return Promise.reject("Token expired");
//     }
//     if (token) {
//       config.headers.Authorization = `Bearer ${token}`;
//     }
//     return config;
//   },
//   (error) => Promise.reject(error)
// );


